




































import { Vue, Component } from 'vue-property-decorator';
import NewsList from '../components/NewsList.vue';
import * as config from '../config';
import { getVoteList } from '@/api/api';
import DetailModal from '../components/DetailModal.vue';
import BottomTabbar from '../components/BottomTabbar.vue';
import Rule from '../components/Rule.vue';
import Music from '../components/Music.vue';
import { Popup } from 'vant';
Vue.use(Popup);
type Target = 'detail' | 'success';
@Component({
  components: {
    DetailModal,
    BottomTabbar,
    Rule,
    Music,
  },
})
export default class News extends Vue {
  option = config.OPTHINES;
  ListData: any = [];
  active = 0;
  Detail = {};
  page = 1;
  modalVisible = false;
  target: Target = 'success';
  show: boolean = false;
  async created() {
    const res = await getVoteList({
      voteName: this.option.voteName,
    });
    this.ListData = res.data;
  }
  showContent(item: any) {
    this.Detail = item;
    console.log(item);
    this.modalVisible = true;
  }
  toggleModal() {
    this.modalVisible = false;
  }
  showPopup() {
    this.show = true;
  }
  toggleModal2() {
    this.show = false;
  }
}
